module.exports = __webpack_public_path__ + "img/c06aa0e.png";